$(document).ready(function(){ 
  
$('.accBox:not(.active) .contentBx').slideUp(500);
$('.accBox.active .contentBx').slideDown(500);
  
$('.accBox > .headingBox').click(function(){
    if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
        $(this).next('.contentBx').slideUp(500);
    }else{
        $('.accBox').removeClass('active');
        $('.accBox').children('.contentBx').slideUp(500);
        $(this).parent().addClass('active');
        $(this).next('.contentBx').slideDown(500);
    }   
 })

  
 }) //  jQuery doc end



 document.addEventListener('DOMContentLoaded', function () {
   
    const splideCollection = new Splide('#splidefeature',{
      type      : 'loop',
      perPage   : 4,  // Default for large screens
      autoplay  : false,
      interval  : 3000, // Time between slides in milliseconds
      arrows    : true,
      pagination: false,
      
      breakpoints: {
        1200: {
          perPage: 3,  // Show 3 slides per page for screens ≤ 1200px
        },
        992: {
          perPage: 2,  // Show 2 slides per page for screens ≤ 992px
        },
        481: {
          perPage: 1,  // Show 1 slide per page for screens ≤ 768px
        },
      }
    });

    const progressBar = document.querySelector('#splidefeature .my-slider-progress-bar');

    splideCollection.on( 'mounted move', function () {
      var end = splideCollection.Components.Controller.getEnd() + 1;
      progressBar.style.width = String( 100 * ( splideCollection.index + 1 ) / end ) + '%';
    } );

    splideCollection.mount();


   
// Review slider
  
   const review = new Splide("#cardSlider1", {
      type: "loop",
      perPage: 5,
      arrows: false,
      pagination: false,
      pauseOnHover: true,
      autoScroll: {
        speed: 1
      },
      focus: "center",
      gap: "3rem",
      breakpoints: {
        1200: {
          perPage: 4,
          gap: "2rem"
        },
        
        768: {
          perPage: 3,
          gap: "1rem"
        },
        576: {
          perPage: 2,
          gap: "0.5rem"
        }
      }
    }).mount(window.splide.Extensions);

   const review2 = new Splide("#cardSlider2", {
      type: "loop",
      perPage: 5,
      arrows: false,
      pagination: false,
      pauseOnHover: true,
      autoScroll: {
        speed: -1
      },
      focus: "center",
      gap: "3rem",
      breakpoints: {
        1200: {
          perPage: 4,
          gap: "2rem"
        },
        768: {
          perPage: 3,
          gap: "1rem"
        },
        576: {
          perPage: 2,
          gap: "0.5rem"
        }
      }
    }).mount(window.splide.Extensions);


   // logo slider

    const logoSlider = new Splide('#logoSlider', {
        type: "loop",
      perPage: 20,
      arrows: false,
      pagination: false,
      pauseOnHover: true,
      autoWidth: true,
      pauseOnHover:true,
      autoScroll: {
        speed: 0.5
      },
      focus: "center",
      gap: "1rem",    
      }).mount(window.splide.Extensions);
   

   
   
  }) // end javascript doc






/* ----------------------------------------
   DAILY RESET COUNTDOWN TIMER (MIDNIGHT)
------------------------------------------- */

function startDailyResetTimer() {
  const timerEl = document.getElementById("daily-timer");
  if (!timerEl) return;

  function getResetTime() {
    let saved = localStorage.getItem("daily_reset_time");
    let now = Date.now();

    // If no saved time OR past midnight → set next midnight
    if (!saved || now > saved) {
      const nextMidnight = new Date();
      nextMidnight.setHours(24, 0, 0, 0); 
      localStorage.setItem("daily_reset_time", nextMidnight.getTime());
      return nextMidnight.getTime();
    }

    return parseInt(saved, 10);
  }

  let resetTime = getResetTime();

  function updateTimer() {
    let now = Date.now();
    let diff = resetTime - now;

    // If passed midnight → reset
    if (diff <= 0) {
      localStorage.removeItem("daily_reset_time");
      resetTime = getResetTime();
      diff = resetTime - now;
    }

    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    timerEl.textContent =
      `${String(hours).padStart(2, "0")}:` +
      `${String(minutes).padStart(2, "0")}:` +
      `${String(seconds).padStart(2, "0")}`;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

/* ----------------------------------------
   STOCK SWITCHER (Variant Change Listener)
------------------------------------------- */

document.addEventListener(PUB_SUB_EVENTS.variantChange, function (event) {
  const variant = event.detail.data.variant;
  if (!variant) return;

  const inStockBox = document.querySelector(".in-stock");
  const outStockBox = document.querySelector(".out-stock");

  if (!inStockBox || !outStockBox) return;

  if (variant.available) {
    // Show in-stock block
    inStockBox.classList.remove("hidden");
    outStockBox.classList.add("hidden");

    // Start timer for in-stock variant
    startDailyResetTimer();
  } else {
    // Show out-of-stock block
    inStockBox.classList.add("hidden");
    outStockBox.classList.remove("hidden");
  }
});

/* ----------------------------------------
   START TIMER ON PAGE LOAD
   (BUT ONLY IF DEFAULT VARIANT IS IN STOCK)
------------------------------------------- */

document.addEventListener("DOMContentLoaded", function () {
  const inStockBox = document.querySelector(".in-stock");

  // If default variant is in stock → start timer
  if (inStockBox && !inStockBox.classList.contains("hidden")) {
    startDailyResetTimer();
  }
});


document.querySelectorAll('.template-product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();

    // Main CTA button
    const mainCTA = document.querySelector('.product-form__buttons .product-form__submit');
    if (!mainCTA) return;

    // 👉 Scroll smoothly to main CTA
    mainCTA.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // 👉 Trigger the click event AFTER scroll (small delay)
    setTimeout(() => {
      mainCTA.click();
    }, 300);
  });
});

